/*!
* authllizer-facebook-oauth2 (https://github.com/yisraelx/authllizer#readme)
* @version 0.2.0
* @license MIT
* @copyright Yisrael Eliav <yisraelx@gmail.com> (https://github.com/yisraelx)
*/
(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('@authllizer/core')) :
    typeof define === 'function' && define.amd ? define(['exports', '@authllizer/core'], factory) :
    (global = global || self, factory(global['authllizer-facebook-oauth2'] = {}, global['@authllizer/core']));
}(this, (function (exports, core) { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0

    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.

    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    /**
     * @resource https://developers.facebook.com/docs/facebook-login/manually-build-a-login-flow/
     */
    var FacebookOAuth2 = /** @class */ (function (_super) {
        __extends(FacebookOAuth2, _super);
        function FacebookOAuth2() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.name = 'facebook';
            _this.authorizationEndpoint = 'https://www.facebook.com/v4.0/dialog/oauth';
            _this.redirectUri = window.location.origin + '/';
            _this.scopeParams = ['email'];
            _this.scopeDelimiter = ',';
            _this.displayOptions = { width: 580, height: 400 };
            _this.dialogParams = ['display'];
            _this.display = 'popup';
            return _this;
        }
        return FacebookOAuth2;
    }(core.OAuth2Provider));

    exports.default = FacebookOAuth2;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=authllizer-facebook-oauth2.umd.js.map
